<template>
    <BModal id="des1-modal"
            v-bind:no-close-on-backdrop=true
            dialogClass="modal-dialog modal-lg"
            bodyClass="p-3" v-model="modalShow" size="xl">
        <template #header>
            <h2>
                Редагування умов оплати і постачання
            </h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed"
                        v-on:click="modalShow = !modalShow">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        <div class="condition_info pl-1 pl-1">
            <div id="payment">
                <div class="col-sm-12">
                    <div class="">
                        <BFormCheckbox id="payment_ok" v-model="push_request.payment_ok" name="checkbox-2">
                            <span class="text fw-600" style="margin-left: 5px;margin-top: -2px">
                               З умовами оплати згоден
                            </span>
                        </BFormCheckbox>
                    
                        <payment v-if="!push_request.payment_ok" :payment="push_request.payment"></payment>
                    </div>
                </div>
            </div>
            
            <div id="delivery">
                <div class="col-sm-12">
                    <div class="">
                        <BFormCheckbox id="delivery_ok" class="" v-model="push_request.delivery_ok" name="checkbox-3">
                            <span class="text fw-600" style="margin-left: 5px;margin-top: -2px">
                              З умовами постачання згоден
                            </span>
                        </BFormCheckbox>
                        
                        <BFormGroup class="col-md-6 pb-4 " id="deliverys-input-group" label="Умови постачання"
                                    v-if="!push_request.delivery_ok">
                            <v-select
                                label="title"
                                :options="deliveries"
                                :reduce="delivery => delivery.id"
                                v-model="push_request.delivery_id"
                            ></v-select>
                        </BFormGroup>
                    
                    </div>
                </div>
            </div>
            
            <div id="date_delivery">
                <div class="col-sm-12">
                    <div class="">
                        <BFormCheckbox id="date_delivery_ok" v-model="push_request.date_delivery_ok" name="checkbox-4">
                            <span class="text fw-600" style="margin-left: 5px;margin-top: -2px">
                             З датою почтачання згоден
                            </span>
                        </BFormCheckbox>
                        
                        <BFormGroup v-if="!push_request.date_delivery_ok" class="col-md-6"
                                    label="Очікувана дата постачання">
                            <date-picker
                                v-model:value="push_request.date_delivery"
                                :lang="d_lang"
                                type="date"
                                value-type="format"
                                format="YYYY-MM-DD"
                                :first-day-of-week="1"
                            ></date-picker>
                        </BFormGroup>
                    
                    </div>
                </div>
            </div>
        </div>
        
        <template #footer>
            <div class="main_buttons">
                <BButton :disabled="!canPut" size="lg" class="me-2" variant="outline-primary" @click="pushPayment">
                    Зберегти свої умови
                </BButton>
            </div>
        </template>
    </BModal>
</template>

<script>

import vSelect from 'vue-select';
import DatePicker from 'vue-datepicker-next';
import {
    BButton,
    BFormCheckbox,
    BInput,
    BFormGroup,
    BModal
} from 'bootstrap-vue-next';

import payment from "../../../sale/tender/create/tabs/fields/payment.vue";

export default {
    name: "request_modal_custom_modal",
    
    components: {
        payment,
        BModal,
        BFormCheckbox,
        BButton,
        BFormGroup,
        vSelect,
        DatePicker
    },
    
    emits : [
        'override_finish'
    ],
    props: {
        request: {
            type: Object,
            required: true
        }
    },
    
    data() {
        return {
            modalShow: false,
            deliveries: [],
            push_request: {
                payment_ok: true,
                delivery_ok: true,
                date_delivery_ok: true,
                delivery_id: null,
                date_delivery: null,
                payment: {
                
                },
            }
        }
    },
    
    created() {
        EventBus.$on('show_payment_edit', this.show);
        this.loadDeliveries();
    },
    
    methods: {
        
        async loadDeliveries() {
            this.deliveries = [];
            await api.get('/tenders/list/deliveries').then(({data}) => {
                if (data.status === "operation_success") {
                    this.deliveries = data.data;
                }
            })
        },
        
        show() {
            if (this.request.hasOwnProperty('override')) {
                this.push_request = this.request.override;
            }
            this.modalShow = true;
            
        },
        
        pushPayment() {
            
            this.$emit('override_finish',this.push_request);
            this.modalShow = false;
        },
    },
    
    computed: {
        canPut() {
            return true;
        },
        
        d_lang() {
            return window.dLang.lang;
        },
    }
}
</script>


<style scoped>

</style>